import { Component } from "react";
import { compose } from "redux";

import { DatePicker } from "@material-ui/pickers/DatePicker";

import TableNew, { CELL_TYPES } from "../../../shared/Table";

import { reportsConnector } from "../../../services/reports/connector";

class ReportsMonthYearCell extends Component {
  render() {
    return (
      <div>
        {this.props.item.Month}/{this.props.item.Year}
      </div>
    );
  }
}

class UCReportsComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      {
        key: "Month",
        label: "Month/Year",
        visible: true,
        renderer: (value, item) => {
          return <ReportsMonthYearCell item={item} value={value} />;
        },
      },
      {
        key: "NumberOfRegisteredCredits",
        label: "Number of registered credits",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "NumberOfMisbehavedCredits",
        label: "Number of misbehaved credits",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "CreditRegistrationReportUploadDate",
        label: "Credit registration report upload date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "CreditMisbehaveReportUploadDate",
        label: "Credit misbehave report upload date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "ReportDate",
        label: "Report date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "CreditRegistrationReportName",
        label: "Registration report name",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "CreditMisbehaveReportName",
        label: "Misbehave report name",
        visible: true,
        type: CELL_TYPES.text,
      },
    ];

    var dateTo = new Date();
    var dateFrom = new Date(dateTo.getFullYear(), dateTo.getMonth() - 1);

    this.state = { columns, to: dateTo, from: dateFrom };
  }

  handleChangeFrom = (date) => {
    this.setState({
      ...this.state,
      from: date,
    });
  };

  handleChangeTo = (date) => {
    this.setState({
      ...this.state,
      to: date,
    });
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h3>UC Reports:</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                From date
                <br />
                <DatePicker
                  inputVariant="outlined"
                  className="small-datepicker"
                  value={this.state.from}
                  onChange={this.handleChangeFrom}
                  helperText="From date"
                />
              </div>
              <div className="col-md-6">
                To date
                <br />
                <DatePicker
                  inputVariant="outlined"
                  className="small-datepicker"
                  value={this.state.to}
                  onChange={this.handleChangeTo}
                  helperText="To date"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.props.reports.ucReports.fetched ? (
              <div>
                <TableNew
                  columns={this.state.columns}
                  items={this.props.reports.ucReports.data}
                  tableKey="ucReports"
                />
              </div>
            ) : this.props.reports.ucReports.fetching ? (
              <div className="col-md-12">Fetching data...</div>
            ) : (
              <div className="col-md-12">No data</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default compose(reportsConnector)(UCReportsComponent);
